import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModuleProgressDetailPage } from './module-progress-detail.page';

const routes: Routes = [
  {
    path: '',
    component: ModuleProgressDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModuleProgressDetailPageRoutingModule {}
